import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaBriefcase, FaCalendarAlt, FaMapMarkerAlt } from 'react-icons/fa';
import './Experience.css';

const Experience = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const experiences = [
    {
      id: 1,
      title: "Junior Full Stack Developer",
      company: "Adhir Info",
      period: "2024 - Present",
      location: "On-site",
      description: "Worked on full-stack web applications using Angular, Django, and PostgreSQL. Implemented UI components, integrated REST APIs, and supported backend development while continuously improving skills and adhering to development best practices.",
      achievements: [
        "Built and maintained features using Angular and Django",
        "Integrated APIs and managed data with PostgreSQL",
        "Resolved bugs and improved application reliability",
        "Worked in a team environment following Git-based workflows"
      ],      
      technologies: ["Angular", "Django","postgres"]
    },
    
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2>Work Experience</h2>
          <p className="section-subtitle">
            My professional journey and career milestones
          </p>
        </motion.div>

        <div className="experience-timeline" ref={ref}>
          {experiences.map((exp, index) => (
            <motion.div 
              key={exp.id}
              className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <div className="timeline-content">
                <div className="timeline-header">
                  <h3>{exp.title}</h3>
                  <div className="timeline-meta">
                    <span className="company">
                      <FaBriefcase />
                      {exp.company}
                    </span>
                    <span className="period">
                      <FaCalendarAlt />
                      {exp.period}
                    </span>
                    <span className="location">
                      <FaMapMarkerAlt />
                      {exp.location}
                    </span>
                  </div>
                </div>
                
                <p className="timeline-description">{exp.description}</p>
                
                <div className="timeline-achievements">
                  <h4>Key Achievements:</h4>
                  <ul>
                    {exp.achievements.map((achievement, idx) => (
                      <li key={idx}>{achievement}</li>
                    ))}
                  </ul>
                </div>
                
                <div className="timeline-technologies">
                  {exp.technologies.map((tech) => (
                    <span key={tech} className="tech-badge">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="experience-summary"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <div className="summary-card">
            <h3>Career Highlights</h3>
            <div className="summary-stats">
              <div className="summary-stat">
                <div className="stat-number">1+</div>
                <div className="stat-label">Years Experience</div>
              </div>
              
              <div className="summary-stat">
                <div className="stat-number">2</div>
                <div className="stat-label">Technologies Mastered</div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;
